export default __webpack_public_path__ + "static/media/suite-montanha1-2.a031e8be.jpg";